import "./src/styles/global.css";
import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";
import React from "react"
import { AuthProvider } from "./src/services/AuthContext";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY || "AIzaSyA5Ue5e_oiIAjIq_0OATLtYKiesn_3jh5c",
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || "pdv-orleans-dev.firebaseapp.com",
  databaseURL: process.env.FIREBASE_DATABASE_URL || "https://pdv-orleans-dev.firebaseio.com",
  projectId: process.env.FIREBASE_PROJECT_ID || "pdv-orleans-dev",
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET || "pdv-orleans-dev.appspot.com",
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "888297678864",
  appId: process.env.FIREBASE_APP_ID || "1:888297678864:web:6f0b929293657fc64c4295",
};

const app = initializeApp(firebaseConfig);

const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

// Analytics seulement côté client
if (typeof window !== 'undefined') {
  getAnalytics(app);
}

export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      {element}
    </AuthProvider>
  )
}
